module.exports = __webpack_public_path__ + "static/media/eye-off.0e7d5dd4.svg";